import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./EnrichedIcon.less";
import type { IEnrichedIconProps } from "./EnrichedIcon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 116 116"
    {...props}
  >
    <path
      fill="#F1F4FA"
      d="M58 109c28.167 0 51-22.833 51-51 0-28.166-22.833-51-51-51C29.834 7 7 29.834 7 58c0 28.167 22.834 51 51 51"
    />
    <path
      fill="#ACB8C3"
      d="M103.09 24.03a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5"
    />
    <path
      fill="#C7D0D9"
      d="m88.23 7.08 3.94-3.94c.59-.59.59-1.54 0-2.12s-1.54-.59-2.12 0l-3.94 3.94-3.94-3.94a1.49 1.49 0 0 0-2.12 0c-.58.59-.59 1.54 0 2.12l3.94 3.94-3.94 3.94a1.49 1.49 0 0 0 0 2.12c.29.29.68.44 1.06.44s.77-.15 1.06-.44l3.94-3.94 3.94 3.94c.29.29.68.44 1.06.44s.77-.15 1.06-.44c.59-.59.59-1.54 0-2.12zM6.57 84.46a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7M93.17 93.85H87.6v-5.57c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v5.57h-5.57c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5h5.57v5.57c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5v-5.57h5.57c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5M24.85 101.35c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6m0-10c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4M18.37 34.12S7.75 55.06 10.38 63.38s14.32 6.49 15.99-.71-7.99-28.55-8-28.55"
    />
    <path
      fill="#7B8493"
      d="M18.26 76.05c-1.24 0-2.25-1.01-2.25-2.25V61.56c0-1.24 1.01-2.25 2.25-2.25s2.25 1.01 2.25 2.25V73.8c0 1.24-1.01 2.25-2.25 2.25M53.01 82.88H22.43a2.59 2.59 0 0 1 0-5.18h30.58a2.59 2.59 0 0 1 0 5.18"
    />
    <path
      fill="#C7D0D9"
      d="M69.99 39.25 54.3 26.74c-.75-.6-1.82-.6-2.57 0L36.04 39.25v28.17c0 1.71 1.38 3.09 3.09 3.09h27.78c1.71 0 3.09-1.38 3.09-3.09V39.25M69.99 37.68V26.61c0-.49-.4-.89-.89-.89h-4.39c-.49 0-.89.4-.89.89v7.06"
    />
    <path
      fill="#fff"
      d="M48.76 49.36h8.63c1.31 0 2.37 1.06 2.37 2.37V70.5H46.4V51.73c0-1.31 1.06-2.37 2.37-2.37z"
    />
    <path
      fill="#ACB8C3"
      d="M76.16 45.31c-.53 0-1.07-.16-1.53-.5L53.3 29.17a.495.495 0 0 0-.59 0L31.38 44.81c-1.15.84-2.78.6-3.62-.56a2.58 2.58 0 0 1 .56-3.62l21.33-15.64a5.67 5.67 0 0 1 6.72 0L77.7 40.63a2.6 2.6 0 0 1 .56 3.62c-.51.69-1.29 1.06-2.09 1.06zM73.18 73.09H32.65a2.59 2.59 0 0 1 0-5.18h40.53a2.59 2.59 0 0 1 0 5.18"
    />
    <path
      fill="#C7D0D9"
      d="M99.89 48.85 84.2 36.34c-.75-.6-1.82-.6-2.57 0L65.94 48.85v28.17c0 1.71 1.38 3.09 3.09 3.09h27.78c1.71 0 3.09-1.38 3.09-3.09V48.85M99.89 47.28V36.21c0-.49-.4-.89-.89-.89h-4.39c-.49 0-.89.4-.89.89v7.06"
    />
    <path
      fill="#fff"
      d="M78.66 58.97h8.63c1.31 0 2.37 1.06 2.37 2.37v18.77H76.3V61.34c0-1.31 1.06-2.37 2.37-2.37z"
    />
    <path
      fill="#ACB8C3"
      d="M106.06 54.92c-.53 0-1.07-.16-1.53-.5L83.2 38.78a.495.495 0 0 0-.59 0L61.28 54.42c-1.15.84-2.77.6-3.62-.56a2.58 2.58 0 0 1 .56-3.62L79.55 34.6a5.67 5.67 0 0 1 6.72 0l21.33 15.64a2.6 2.6 0 0 1 .56 3.62c-.51.69-1.29 1.06-2.09 1.06zM103.09 82.7H62.56a2.59 2.59 0 0 1 0-5.18h40.53a2.59 2.59 0 0 1 0 5.18"
    />
  </svg>
);
const SvgEnrichedIconNeighborhoodGreyscale = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IEnrichedIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("enriched-icon bds-enriched-icon", className, {
        ["bds-enriched-icon-" + size]: size,
        ["enriched-icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgEnrichedIconNeighborhoodGreyscale);
export default Memo;
